// vendor
import { defineComponent, ref, reactive, watch } from "@vue/composition-api";
// project
import { matchEmail } from "@utils/text";

import { useTranslate } from "@lang";

type FormData  = {
	email:string,
	password:string
};

export const LoginForm = defineComponent({
	
	setup(props, context){

		const { translate } = useTranslate();

		const error = ref<string|null>(null);
		const formData = reactive<FormData>({ email:"", password:"" });

		watch(formData, () => error.value = null);

		const submit = async () => {
			if(formData.email.length === 0){ error.value = translate("auth.error.emailIsRequired"); }
			else if(!matchEmail(formData.email)){ error.value = translate("auth.error.invalidEmail"); }
			else if(formData.password.length === 0){ error.value = translate("auth.error.passwordIsRequired"); }
			if(error.value){ return; }
			try{
				await context.root.$store.dispatch("login", formData);
				context.root.$router.push("/");
			}catch(err){
				error.value = translate("auth.error.invalidCredentials");
			}
		}

		if(context.root.$store.getters.authenticated){
			context.root.$router.push("/");
		}

		return {
			error,
			formData,
			submit,
			translate,
		};
	}
});